import { Controller } from "@hotwired/stimulus";
import IMask from "imask";
import Rails from "rails-ujs";

export default class extends Controller {
  static targets = ["calculationModelInput", "inputToUpdate", "cloneInput"];

  connect() {
    this.recalculateUrl = this.element.dataset.recalculateUrl;
    this.requestToken = 0;

    this.element.addEventListener("change", () => this.recalculate());
  }

  changeCalculationModel = (event) => {
    const { value } = event.target;

    if (value == "MANUAL") {
      this.calculationModelInputTargets.forEach((input) =>
        input.removeAttribute("disabled")
      );
    } else {
      this.calculationModelInputTargets.forEach((input) =>
        input.setAttribute("disabled", true)
      );
    }

    // No recalculate() here: the select's change bubbles up to the form's own
    // listener, which asks for it once the inputs above are toggled.
  };

  recalculate = () => {
    // Only the newest request may fill the form: an older answer landing last
    // would bring back figures computed from outdated amounts.
    const token = ++this.requestToken;
    const sentValues = new Map(
      this.inputToUpdateTargets.map((input) => [input, input.value])
    );
    const data = $(this.element)
      .find("input[name!=_method], select")
      .serialize();

    Rails.ajax({
      url: this.recalculateUrl,
      type: "POST",
      data: data,
      success: (data) => {
        if (token !== this.requestToken) return;

        this.updateForm(data, sentValues);
        this.updateClones();
      },
    });
  };

  updateForm = (data, sentValues) => {
    this.inputToUpdateTargets.forEach((input) => {
      // Typed into after the form was sent: the answer knows nothing of it,
      // and the change that typing fires asks for a newer one.
      if (input.value !== sentValues.get(input)) return;

      const inputNameSplitted = input.name.split(/[\[\]]/).filter(String);
      const field = inputNameSplitted.pop();

      if (field) {
        let value = 0

        if (!isNaN(data[field])) {
          value =  parseFloat(data[field]).toFixed(2);
        }
        input.value = "";
        input.value = value.toString();

        // trigger change to update mask
        const event = new CustomEvent("outsideChange");
        input.dispatchEvent(event);
      } else {
        console.warn(`field ${field} not found`);
      }
    });
  };

  updateClones = () => {
    this.cloneInputTargets.forEach((input) => {
      const { copyFrom } = input.dataset;
      const fromInput = document.querySelector(copyFrom);
      input.value = fromInput.value;
    });
  };

  formatToReal = (value) => {
    if (this.currencyFormatter == null) {
      this.currencyFormatter = IMask.createMask({
        mask: Number,
        scale: 2,
        signed: true,
        thousandsSeparator: ".",
        padFractionalZeros: true,
        normalizeZeros: false,
        radix: ",",
        mapToRadix: ["."],
      });
    }

    return this.currencyFormatter.resolve(value);
  };
}
